import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { object, string, array, func, bool } from "prop-types";
import Checkbox from "./Checkbox.js";
import ThumbnailCheckbox from "./ThumbnailCheckbox.js";
import Col from "../grid/Col.js";
import Row from "../grid/Row.js";
import SearchInput from "../input/SearchInput";

import "./CheckboxContainer.css";

class CheckboxContainer extends PureComponent {
  static PropTypes = {
    errors: object,
    title: string,
    name: string,
    checkboxData: array,
    onCheckboxChange: func,
    onCheckboxEditButtonClick: func,
    checkAgainst: array,
    thumbnails: bool
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false,
      msgs: [],
      searchText: ""
    };

    this.renderErrors = this.renderErrors.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  renderErrors() {
    if (!this.state.error) {
      return null;
    } else {
      return (
        <ul className="errors">
          {this.state.msgs.map((msg, i) => (
            <li className="error-msg" key={i}>
              {msg}
            </li>
          ))}
        </ul>
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      //check if this.props.name is in Object.keys()
      if (Object.keys(nextProps.errors).includes(this.props.name)) {
        this.setState({ error: true, msgs: nextProps.errors[this.props.name] });
      }
    }
  }

  handleChange(searchText) {
    this.setState({ searchText });
  }
  render() {
    const { hideInput, checkboxData } = this.props;
    const { searchText } = this.state;

    const filteredChecboxData =
      checkboxData &&
      checkboxData.filter(cd =>
        cd.display_name.toLowerCase().includes(searchText.toLowerCase())
      );

    return (
      <Col _bottom-16 checkbox-container>
        <Row _no-grow _space-between>
          <h2 className="checkbox-label">{this.props.title} {this.props.isOptional && <span style={{fontSize: '12px', fontStyle: 'italic', marginLefth: '5px'}}>(Optional)</span>}</h2>
          {!hideInput && (
            <SearchInput ph="search" onChange={this.handleChange} />
          )}
        </Row>
        <Col _bottom-16>
          {this.renderErrors()}

          {!this.props.thumbnails &&
            filteredChecboxData.map((cd, i) => (
              <Checkbox
                key={i}
                name={this.props.name}
                value={cd.value}
                onCheckboxClick={this.props.onCheckboxChange}
                onEditButtonClick={this.props.onCheckboxEditButtonClick}
                onDeleteButtonClick={this.props.onCheckboxDeleteButtonClick}
                text={cd.display_name}
                checked={
                  this.props.checkAgainst
                    ? this.props.checkAgainst.some(
                        item => item.value === cd.value
                      )
                    : null
                }
              />
            ))}

          {this.props.thumbnails &&
            filteredChecboxData.map((cd, i) => (
              <ThumbnailCheckbox
                key={i}
                name={this.props.name}
                value={cd.value}
                thumbnail={cd.thumbnail}
                onCheckboxClick={this.props.onCheckboxChange}
                text={cd.display_name}
                checked={
                  this.props.checkAgainst
                    ? this.props.checkAgainst.some(
                        item => item.value === cd.value
                      )
                    : null
                }
              />
            ))}
        </Col>
      </Col>
    );
  }
}

const mapStateToProps = state => ({ errors: state.errors });

export default connect(mapStateToProps)(CheckboxContainer);



// WEBPACK FOOTER //
// ./src/common/checkbox/CheckboxContainer.js